/* import __COLOCATED_TEMPLATE__ from './postings-results-list.hbs'; */
import { readOnly } from '@ember/object/computed';
import { computed } from '@ember/object';
import { A } from '@ember/array';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { ASSIGNMENT } from "../../models/assignment";
import { POSTINGS_NETWORK_FILTER_API_ENUMS } from "../../constants/routes/postings";

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: 'ul',
  classNames: ['SH-c-postings-results-list'],
  classNameBindings: ['state.isEmptyDefaultSearch:margin-top-32px'],

  /**
   * Register services
   */
  state: service('states/routes/postings'),

  /**
   * Array of Assignment models to show results for.
   *
   * @param {Ember.MutableArray}
   */
  assignmentListItems: A(),

  /**
   * Define the callback when the user initiates a new posting.
   *
   * @param {Function}
   */
  onNewPostingInitiated() {
    throw new Error('need to define onNewPostingInitiated handler');
  },

  /**
   * True when we have at least 1 assignments
   *
   * @type {Boolean}
   * @private
   */
  _hasListItems: computed('assignmentListItems.length', function() {
    return !!this.get('assignmentListItems.length');
  }),

  /**
   * True if we have NOT searched yet.  Different than a search with no results.
   *
   * @type {Boolean}
   */
  _hasNotSearchedYet: readOnly('state.hasNotSearchedYet'),

  /**
   * True when the assignment status is 'closed'
   *
   * @type {Boolean}
   * @private
   */
  _isClosed: computed('state.currentAssignmentStatus', function() {
    return this.get('state.currentAssignmentStatus') === ASSIGNMENT.STATUS.CLOSED;
  }),

  /**
   * True when the assignment status is 'draft'
   *
   * @type {Boolean}
   * @private
   */
  _isDraft: computed('state.currentAssignmentStatus', function() {
    return this.get('state.currentAssignmentStatus') === ASSIGNMENT.STATUS.DRAFT;
  }),

  /**
   * True when the assignment status is 'in-review'
   *
   * @type {Boolean}
   * @private
   */
  _isInReview: computed('state.currentAssignmentStatus', function() {
    return this.get('state.currentAssignmentStatus') === ASSIGNMENT.STATUS.DRAFT;
  }),

  /**
   * True when the assignment status is 'live'
   *
   * @type {Boolean}
   * @private
   */
  _isLive: computed('state.currentAssignmentStatus', function() {
    return this.get('state.currentAssignmentStatus') === ASSIGNMENT.STATUS.LIVE;
  }),

  /**
   * True when we want to show a specific message for an empty user filter change. i.e. not the default filter
   *
   * @type {Boolean}
   */
  _isShowFilterSpecificEmptyMessage: computed('state.networkFilterSelectedValue', function() {
    return this.get('state.networkFilterSelectedValue') !== POSTINGS_NETWORK_FILTER_API_ENUMS.POSTED_BY_ANYONE;
  }),

  /**
   * True if we want to show loader
   *
   * @type {Boolean}
   * @private
   */
  _isShowSearchLoader: computed('state.isLoadingResult', 'state.assignmentListItems', function() {
    return this.get('state.isLoadingResult') && !this.get('state.assignmentListItems.length');
  }),

  /**
   * True when the search component is activated
   *
   * @type {Boolean}
   * @private
   */
  _isSearchActivated: readOnly('state.isSearchActivated'),

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * Called when the new posting button has been clicked on.
     *
     * @private
     */
    _onStartNewPostingClicked: function() {
      this.onNewPostingInitiated();
    }
  }
});
